import {
  BOOKING_STATUS_LABELS,
  PAYMENT_STATUS_LABELS,
  isOverdue,
  paymentStatusClass,
} from "@/lib/bookingLabels";
import type { BookingStatus, PaymentStatus } from "@/types/database";

export function PaymentStatusBadge({
  paymentStatus,
  bookingStatus,
  dueDate,
}: {
  paymentStatus: PaymentStatus;
  bookingStatus: BookingStatus;
  dueDate?: string | null;
}) {
  const label =
    bookingStatus === "cancelled"
      ? "Cancelled"
      : isOverdue(paymentStatus, dueDate)
        ? "Overdue"
        : PAYMENT_STATUS_LABELS[paymentStatus];

  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] uppercase tracking-wider border ${paymentStatusClass(
        paymentStatus,
        bookingStatus,
        dueDate
      )}`}
    >
      {label}
    </span>
  );
}

export function BookingStatusBadge({ status }: { status: BookingStatus }) {
  return (
    <span className="inline-flex items-center px-2.5 py-1 rounded-full text-[11px] uppercase tracking-wider border border-white/15 text-white/60 bg-white/5">
      {BOOKING_STATUS_LABELS[status]}
    </span>
  );
}
